<template>
  <div class="form-dialog">
    <div class="form-body-scroll">
      <div class="form-title padding-title">
        {{ title }}
      </div>
      <div class="form-box-body">
        <div class="form-components scroll">
          <div
            class="form_combo_text"
          />
          <div v-if="name.show">
            <div class="form_label">
              Ingresa tu nombre y apellido *
            </div>
            <div class="form__field">
              <label
                for="name"
              ><v-icon
                name="user"
                scale="1"
                style="margin: 0 0 5px 0;"
              /></label>
              <input
                id="name"
                ref="name"
                v-model="name.value"
                autocomplete="off"
                type="text"
                name="name"
                value=""
                placeholder="Visita"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('email')"
                @keypress="keyPressCheckSpecialChars($event, 'name')"
                @change="cleanSpecialChars('name.value', 'name')"
              >
            </div>
          </div>
          <div v-if="phone.show">
            <div class="form_label">
              Teléfono de contacto *
            </div>
            <div class="form__field">
              <label
                for="phone"
              ><v-icon
                name="mobile-alt"
                scale="1"
                style="margin: 0 0 5px 0;"
              /></label>
              <div class="container__input_phone">
                <input
                  value="569"
                  type="text"
                  disabled="true"
                >
                <input
                  id="phone"
                  ref="phone"
                  v-model="phone.value"
                  class="phone"
                  autocomplete="off"
                  type="text"
                  name="phone"
                  value=""
                  placeholder="12345678"
                  required
                  @focus="_clearError"
                  @keypress="keyPressCheckSpecialChars($event, 'phone')"
                  @change="cleanSpecialChars('phone.value', 'phone')"
                >
              </div>
            </div>
          </div>
          <div v-if="email.show">
            <div class="form_label">
              Ingresa tu email *
            </div>
            <div class="form__field">
              <label
                for="email"
              ><v-icon
                name="envelope"
                scale="1"
                style="margin: 0 0 5px 0;"
              /></label>
              <input
                id="email"
                ref="email"
                v-model="email.value"
                class="email"
                autocomplete="off"
                type="text"
                name="email"
                value=""
                placeholder="usuario@dominio.com"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('orderNumber')"
                @keypress="keyPressCheckSpecialChars($event, 'email')"
                @change="cleanSpecialChars('email.value', 'email')"
              >
            </div>
          </div>
          <div v-if="orderNumber.show">
            <div class="form_label">
              Ingresa tu número de pedido *
            </div>
            <div class="form__field">
              <label
                for="orderNumber"
              ><v-icon
                name="shipping-fast"
                scale="1"
                style="margin: 1px 1px 0px;"
              /></label>
              <input
                id="orderNumber"
                ref="orderNumber"
                v-model="orderNumber.value"
                autocomplete="off"
                type="text"
                name="orderNumber"
                value=""
                placeholder="1234"
                required
                maxlength="4"
                @focus="_clearError"
                @keyup.enter="focusTo('address')"
                @keypress="keyPressCheckSpecialChars($event, 'dbsOrderNumber')"
                @change="cleanSpecialChars('orderNumber.value', 'dbsOrderNumber')"
              >
            </div>
          </div>
          <div v-if="address.show">
            <div class="form_label">
              Ingresa la nueva dirección *
            </div>
            <div class="form__field">
              <label
                for="address"
              ><v-icon
                name="map-marker-alt"
                scale="1"
                style="margin: 0 0 5px 0;"
              /></label>
              <input
                id="address"
                ref="address"
                v-model="address.value"
                autocomplete="off"
                type="text"
                name="address"
                value=""
                maxlength="50"
                placeholder="Calle #123"
                required
                @focus="_clearError"
              >
            </div>
          </div>
          <div v-if="comment.show">
            <div class="form_label">
              {{ comment.subtitle }}
            </div>
            <div class="score-comments">
              <textarea
                v-model="comment.value"
                maxlength="200"
                :placeholder="comment.placeholder"
                style="padding: 5px"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- BOTONES -->
      <div class="form-box-button scroll margin_btn">
        <button
          class="button-secondary"
          @click="_cancelClick"
        >
          Cancelar
        </button>
        <button
          class="button-primary"
          @click="_sentClick"
        >
          Enviar
        </button>
      </div>
      <!-- MSG -->
      <div class="form-error">
        &nbsp;{{ errormsg }}
      </div>
    </div>
  </div>
</template>
<script>
import { serverUI } from '../../main'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/envelope'
import 'vue-awesome/icons/map-marker-alt'
import 'vue-awesome/icons/shipping-fast'
import utils from '../../utils'

export default {
  components: {
    'v-icon': Icon
  },
  props: {
    form: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      title: '',
      formType: '',
      text: '',
      contactByOrderStatus: false,
      errormsg: '',
      name: {
        show: true,
        value: ''
      },
      email: {
        show: false,
        value: ''
      },
      phone: {
        show: false,
        value: ''
      },
      orderNumber: {
        show: false,
        value: ''
      },
      address: {
        show: false,
        value: ''
      },
      comment: {
        subtitle: '',
        placeholder: '',
        show: false,
        value: ''
      }
    }
  },
  computed: {},
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', (e) => {
      if (!e.form || e.form === '') return
      if (e.evento === 'newdata') {
        this.title = e.dato.title ? e.dato.title : 'Formulario Naturaloe'
        this.text = e.dato.text ? e.dato.text : ''
        this.contactByOrderStatus = (e.dato.fields && e.dato.fields.fromOrderStatus) ? e.dato.fields.fromOrderStatus : false

        if (e.form === 'naturaloeOrderProblemsForm') {
          this.email.show = true
          this.orderNumber.show = true
          this.comment.show = true
          if (this.title === 'Producto Dañado') {
            this.formType = 'naturaloe-problemas-pedido-producto-danado-confirm'
            this.comment.subtitle = 'Detalle'
            this.comment.placeholder = 'Ingresa detalles del producto dañado...'
          } else if (this.title === 'Producto Faltante') {
            this.formType = 'naturaloe-problemas-pedido-producto-faltante-confirm'
            this.comment.subtitle = 'Detalle'
            this.comment.placeholder = 'Ingresa detalles del producto faltante...'
          } else if (this.title === 'Devolución Pedido') {
            this.formType = 'naturaloe-problemas-pedido-producto-devolucion-confirm'
            this.comment.subtitle = 'Motivo'
            this.comment.placeholder = 'Ingresa el motivo de la devolución...'
          } else if (this.title === 'Producto Erróneo') {
            this.formType = 'naturaloe-problemas-pedido-producto-erroneo-confirm'
            this.comment.subtitle = 'Código Producto'
            this.comment.placeholder = 'Ingresa el código del o los productos incorrectos...'
          }
        } else if (e.form === 'naturaloePurchaseProblemsForm') {
          this.email.show = true
          if (this.title === 'Error en Pago') this.formType = 'naturaloe-problemas-compra-error-pago-confirm'
          else if (this.title === 'Comprobante no Enviado') this.formType = 'naturaloe-problemas-compra-comprobante-no-enviado-confirm'
        } else if (e.form === 'naturaloeChangeDeliveryAddressForm') {
          this.email.show = true
          this.orderNumber.show = true
          this.address.show = true
          this.formType = 'naturaloe-cambio-direccion-entrega-confirm'
        } else if (e.form === 'naturaloeContactForm') {
          this.phone.show = true
          this.email.show = true
          this.comment.show = true
          this.comment.subtitle = 'Mensaje'
          this.comment.placeholder = 'Ingresa tu consulta o motivo de contacto...'
          if (this.contactByOrderStatus) {
            this.orderNumber.show = true
            this.formType = 'naturaloe-contact-form-order-status-confirm'
          } else this.formType = 'naturaloe-contact-form-confirm'
        }

        this.name.value = e.dato.fields.name ? e.dato.fields.name : ''
        this.email.value = e.dato.fields.email ? e.dato.fields.email : ''
        this.phone.value = e.dato.fields.phone ? e.dato.fields.phone.substring(e.dato.fields.phone.length - 8) : ''
        this.orderNumber.value = e.dato.fields.order ? e.dato.fields.order : ''
        this.address.value = e.dato.fields.address ? e.dato.fields.address : ''
        this.comment.value = ''
      }
    })
  },
  methods: {
    _clearError () {
      this.errormsg = ''
    },
    focusTo (el) {
      if (el === 'pass') this.$refs.password.focus()
    },
    keyPressCheckSpecialChars (evt, type) {
      return utils.keyPressCheckSpecialChars(evt, type)
    },
    cleanSpecialChars (val, type) {
      if (!val) return
      return (this[val] = utils.cleanSpecialChars(this[val], type))
    },
    _sentClick () {
      this.errormsg = ''
      const addressReg = /^([A-Z a-z #]+[\s]*[0-9]+[\s]*)+$/
      if (this.name.show && (!this.name.value || this.name.value === 'Visita')) {
        this.errormsg = 'Debes ingresar tu nombre'
        return
      }
      if (this.email.show && !this.email.value) {
        this.errormsg = 'Debes ingresar tu email'
        return
      }
      if (this.email.show && !utils.isEmail(this.email.value)) {
        this.errormsg = 'Debes ingresar un email válido'
        return
      }
      if (this.orderNumber.show && !this.orderNumber.value) {
        this.errormsg = 'Debes ingresar el número de tu pedido'
        return
      }
      if (this.address.show && !this.address.value) {
        this.errormsg = 'Debes ingresar tu dirección'
        return
      }
      if (this.address.show && !addressReg.test(this.address.value)) {
        this.errormsg = 'Debes ingresar una dirección válida'
        return
      }

      const dataToSend = {
        form: this.form,
        evento: 'sentClick',
        title: this.title,
        data: {
          fields: {
            firstname: this.name.value
          }
        }
      }

      if (this.email.show) dataToSend.data.fields.email = this.email.value
      if (this.phone.show) dataToSend.data.fields.phone = this.phone.value
      if (this.orderNumber.show) dataToSend.data.fields.order = this.orderNumber.value
      if (this.address.show) dataToSend.data.fields.address = this.address.value

      if (this.formType === 'naturaloe-problemas-pedido-producto-danado-confirm' && this.comment.show) dataToSend.data.fields.detalle = this.comment.value
      else if (this.formType === 'naturaloe-problemas-pedido-producto-faltante-confirm' && this.comment.show) dataToSend.data.fields.detalle = this.comment.value
      else if (this.formType === 'naturaloe-problemas-pedido-producto-devolucion-confirm' && this.comment.show) dataToSend.data.fields.motivo = this.comment.value
      else if (this.formType === 'naturaloe-problemas-pedido-producto-erroneo-confirm' && this.comment.show) dataToSend.data.fields.id_producto = this.comment.value
      else if ((this.formType === 'naturaloe-contact-form-confirm' || this.formType === 'naturaloe-contact-form-order-status-confirm') && this.comment.show) dataToSend.data.fields.comment = this.comment.value

      dataToSend.data.type = this.formType

      serverUI.$emit('FormEvent', dataToSend)
    },
    _cancelClick () {
      serverUI.$emit('FormEvent', {
        form: this.form,
        evento: 'cancelClick',
        dato: 'Cancelado'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.form__field {
  margin-bottom: 7px;
}

.form-box-body {
  min-height: 200px;
  height: auto;
  max-height: 300px;
  overflow-y: auto;
}
</style>
